import { ISong } from "../@types/interface.d";

export default class SongWithSort {
  public readonly song: ISong;

  public readonly wins: SongWithSort[] = [];

  public readonly looses: SongWithSort[] = [];

  private game: number = 0;

  constructor(song: ISong) {
    this.song = song;
  }

  public get id(): number { return this.song.id; }

  public get name(): string { return this.song.name; }

  public get winCount(): number { return this.wins.length; }

  public get looseCount(): number { return this.looses.length; }

  public get gameCount(): number { return this.game; }

  public compare(other: SongWithSort): number {
    if (this.isWin(other)) {
      return -1;
    }
    if (this.isLoose(other)) {
      return 1;
    }
    if (other.isWin(this)) {
      return 1;
    }
    if (other.isLoose(this)) {
      return -1;
    }
    return 0;
  }

  public isWin(other: SongWithSort): boolean {
    if (this.wins.find(v => v.id === other.id)) {
      return true;
    }
    return false;
  }

  public isLoose(other: SongWithSort): boolean {
    if (this.looses.find(v => v.id === other.id)) {
      return true;
    }
    return false;
  }

  public win(other: SongWithSort, recursive: boolean = true) {
    if (!this.wins.find(v => v.id === other.id)) {
      this.wins.push(other);
    }
    other.wins.forEach(v => {
      if (!this.wins.find(vv => vv.id === v.id)) {
        this.wins.push(v);
      }
    });
    if (recursive) {
      this.looses.forEach(v => v.win(other, false));
    }
    this.game++;
  }

  public loose(other: SongWithSort, recursive: boolean = true) {
    if (!this.looses.find(v => v.id === other.id)) {
      this.looses.push(other);
    }
    other.looses.forEach(v => {
      if (!this.looses.find(vv => vv.id === v.id)) {
        this.looses.push(v);
      }
    });
    if (recursive) {
      this.wins.forEach(v => v.loose(other, false));
    }
    this.game++;
  }
}
